module.exports = __webpack_public_path__ + "assets/tooltip-icon.f3f80158.svg";